import formatMoney from '../formatMoney';

const updatePrice = ({ priceEl, compareAtPriceEl, price, compareAtPrice, badgeTemplate }) => {
  if (!priceEl) return;

  if (compareAtPriceEl) {
    if (compareAtPrice > price) {
      compareAtPriceEl.textContent = formatMoney(compareAtPrice);
      compareAtPriceEl.classList.remove('hidden');
    } else {
      compareAtPriceEl.textContent = '';
      compareAtPriceEl.classList.add('hidden');
    }
  }
  priceEl.textContent = formatMoney(price);
};

export default updatePrice;
